<c-modal
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  size="lg"
  backdrop="static"
>
  <c-modal-body>
    @let event = invitation.data;
    @let referrer = invitation.referrer;
    @let cover = event.media?.cover;
    @let connected = invitation.relationship?.acknowledged;
    @let state = eventState();
    @if (cover?.src) {
      <!-- @let coverSrc = user || !invitationToken ? cover.src : `${cover.src}?token=${invitationToken}`; -->
      <div class="cover">
        <media-card
          [media]="event.media"
          [rounded]="false"
          [selectable]="false"
          [elevated]="false"
          [mediaTypeIcon]="false">
        </media-card>
        <!-- <img [src]="coverSrc | serverAuthUrl | safeUrl" [alt]="event.name"/> -->
        <div class="avatar">
            <img
            src="/assets/images/default-avatar.jpg"
            class="img-fluid rounded shadow-sm"
            />
        </div>
        <!-- <div class="date-ribbon" [attr.data-date]="event.timeFrom | date: 'dd MMM'"> -->
          <!-- {{ event.timeFrom | date: 'dd MMM' }} -->
        <!-- </div> -->
        <div class="date-ribbon-container">
          <div class="date-ribbon" 
              [style.--ribbon-background-color]="ribbonBackgroundColor()" 
              [style.--ribbon-color]="ribbonColor()">
            <div class="ribbon-content">
              <div class="ribbon-date">{{ event.timeFrom | date:'MMM d, y' }}</div>
              <div class="ribbon-time">{{ event.timeFrom | date:'HH:mm' }}</div>
            </div>
          </div>
        </div>
      </div>
    }
    <div class="content" [style.height.px]="contentHeight()">
      <slide-panel
        #slidePanel
        [id]="slidePanelId()"
        [animate]="true"
        (onSlide)="onSlide($event)"
        *translate="let t; params: { referrerName: referrer?.full_name, conferenceName: event.name}">
        <div *slidePanelLeft="'main'" #panel class="panel panel-main">
          <ng-container>
            @if (user && !connected) {
              <span [innerHtml]="t('invitation.connectAndJoinConference') | safeHtml"></span>
              <span [innerHtml]="t('invitation.acceptOrDecline') | safeHtml" class=""></span>
            } @else {
              <div [innerHtml]="t('invitation.joinConference') | safeHtml"></div>
              <ng-container *ngTemplateOutlet="stateTemplate; context: {event: event}" ></ng-container>
              <!-- @if (canJoin()) {
                <div [innerHtml]="t('invitation.joinOrCancel') | safeHtml"></div>
              } -->
            }
          </ng-container>
        </div>
        <div *slidePanelRight="'join'" #panel class="panel panel-details">
          <div [innerHtml]="t('invitation.connectedConfirmation') | safeHtml"></div>
          <ng-container *ngTemplateOutlet="stateTemplate; context: { event: event }"></ng-container>
          <!-- @if (canJoin()) {
            <div [innerHtml]="t('invitation.joinOrCancel') | safeHtml"></div>
          } -->
        </div>
      </slide-panel>
    </div>
  </c-modal-body>

  <c-modal-footer>
    @if (slidePanelId() === 'main' && user && !connected) {
      <button cButton color="secondary" (click)="decline()">{{ 'actions.decline' | translate }}</button>
      <button cButton color="primary" (click)="accept()">{{ 'actions.accept' | translate }}</button>
    } @else {
      <!-- <button cButton color="secondary" (click)="close()">
        {{ `actions.${ state!='ended' ? 'cancel' : 'close'}` | translate }}
      </button> -->
      @if (canJoin()) {
        <button cButton color="secondary" (click)="close()">{{ 'actions.cancel' | translate }}</button>
        <button cButton 
                color="primary" 
                (click)="join()" 
                [disabled]="state == 'upcoming'">
          {{ 'actions.join' | translate }}
        </button>
      } @else {
        <button cButton color="secondary" (click)="close()">{{ 'actions.close' | translate }}</button>
      }
    }
  </c-modal-footer>
</c-modal>

<ng-template #stateTemplate let-event="event">
  <div 
    class="alert alert-warning mt-3 mb-0 text-center"
    *translate="let t; params: { conferenceName: event.name, date: moment(event.timeFrom).format('ll HH:mm') }">
    @switch (eventState()) {
      @case ('ended') {
        {{ t('invitation.conference.ended') }}
      }
      @case ('live') {
        <span class="live-dot"></span>
        <span>{{ t('invitation.conference.live') }}</span>
      }
      @case ('upcoming') {
        <div [innerHTML]="t('invitation.conference.upcoming')" class="mb-3"></div>
        <countdown 
          [target]="event.timeFrom" 
          [color]="countdownColor" 
          (remaining)="onCountdownRemaining($event)">
        </countdown>
        <div [innerHTML]="t('invitation.joinAvailableTime', { minutes: joinMinutes }) | safeHtml" class="mt-4"></div>
      }
      @case ('imminent') {
        <div [innerHTML]="t('invitation.conference.upcoming')" class="mb-3"></div>
        <countdown 
          [target]="event.timeFrom" 
          [color]="countdownColor" 
          (remaining)="onCountdownRemaining($event)">
        </countdown>
      }
    }
  </div>
</ng-template>